import React, { useState } from "react";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import { getOptionsFromRefList } from "@/util/common_function";
import { useSelector } from "react-redux";


const JailIncidentClassViolationDetail = ({ data, disabled }) => {
  const { showDialog } = useDialog();
  const refList = useSelector((state) => state?.refListReducer?.refLists);

  const onHandleViewCommentClassI = () => {
    const comment = data?.classIComments || "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  const onHandleViewCommentClassII = () => {
    const comment = data?.majorViolationsComments || "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  const onHandleViewCommentClassIII = () => {
    const comment = data?.minorViolationsComments || "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  const majorOptionsAll = getOptionsFromRefList("JailIncidentsMajorViolations", false, false, true);
  const minorOptionsAll = getOptionsFromRefList("JailIncidentsMinorViolations", false, false, true);
  const classIOptionsAll = getOptionsFromRefList("JailIncidentsclassIViolations", false, false, true);

  const majorOptions = majorOptionsAll.filter((_, index) => index !== 0);
  const minorOptions = minorOptionsAll.filter((_, index) => index !== 0);
  const classIOptions = classIOptionsAll.filter((_, index) => index !== 0);

  const initialMajor = {};
  if (data && data.jailIncidentsInvolvedInmateMajorViolation?.length) {
    majorOptions.forEach((option) => {
      initialMajor[`major_${option.value}`] = data.jailIncidentsInvolvedInmateMajorViolation.some(
        (item) => item.jailIncidentsMajorViolationsId === option.value
      );
    });
  }
  const initialMinor = {};
  if (data && data.jailIncidentsInvolvedInmateMinorViolation?.length) {
    minorOptions.forEach((option) => {
      initialMinor[`minor_${option.value}`] = data.jailIncidentsInvolvedInmateMinorViolation.some(
        (item) => item.jailIncidentsMinorViolationsId === option.value
      );
    });
  }
  const initialclassI = {};
  if (data && data.jailIncidentsInvolvedInmateclassIiolation?.length) {
    classIOptions.forEach((option) => {
      initialclassI[`classI_${option.value}`] = data.jailIncidentsInvolvedInmateclassIiolation.some(
        (item) => item.jailIncidentsclassIiolationsId === option.value
      );
    });
  }

  const initialValues = {
    ...initialMajor,
    ...initialMinor,
    ...initialclassI,
    majorViolationsComments: data?.majorViolationsComments || "",
    minorViolationsComments: data?.minorViolationsComments || "",
    classIComments: data?.classIComments || "",
  };

  return (
    <Form name="jailIncidentClassViolationDetail" initialValues={initialValues}>
      {/* Class I Violations */}
      <StyledSectionHeading marginTop="20px">
        <span>Class I Violations</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        {classIOptions.map((option) => (
          <StyledGridCol lg={8} key={option.value}>
            <FormItem
              label={option.label}
              layout="horizontal"
              labelPostion="label-right"
              name={`classI_${option.value}`}
              valuePropName="checked"
            >
              <Checkbox disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        ))}
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="12px">
          <FormItem label="Comments" name="classIComments">
            <TextField inputType="textarea" rows="3" disabled={disabled} />
          </FormItem>
          <Button
            type="secondary"
            color="secondary"
            onClick={onHandleViewCommentClassI}
          >
            View Comments
          </Button>
        </StyledGridCol>
      </StyledGridRow>

      {/* Class II Violations */}
      <StyledSectionHeading marginTop="20px">
        <span>Class II Violations</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        {majorOptions.map((option) => (
          <StyledGridCol lg={8} key={option.value}>
            <FormItem
              label={option.label}
              layout="horizontal"
              labelPostion="label-right"
              name={`major_${option.value}`}
              valuePropName="checked"
            >
              <Checkbox disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        ))}
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="12px">
          <FormItem label="Comments" name="majorViolationsComments">
            <TextField inputType="textarea" rows="3" disabled={disabled} />
          </FormItem>
          <Button
            type="secondary"
            color="secondary"
            onClick={onHandleViewCommentClassII}
          >
            View Comments
          </Button>
        </StyledGridCol>
      </StyledGridRow>

      {/* Class III Violations */}
      <StyledSectionHeading marginTop="20px">
        <span>Class III Violations</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        {minorOptions.map((option) => (
          <StyledGridCol lg={8} key={option.value}>
            <FormItem
              label={option.label}
              layout="horizontal"
              labelPostion="label-right"
              name={`minor_${option.value}`}
              valuePropName="checked"
            >
              <Checkbox disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        ))}
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="12px">
          <FormItem label="Comments" name="minorViolationsComments">
            <TextField inputType="textarea" rows="3" disabled={disabled} />
          </FormItem>
          <Button
            type="secondary"
            color="secondary"
            onClick={onHandleViewCommentClassIII}
          >
            View Comments
          </Button>
        </StyledGridCol>
      </StyledGridRow>
      </Form >
  );
};

export default JailIncidentClassViolationDetail;
